import ApiServiceBase from '@/services/ApiServiceBase'

export const namespaced = true

export class HistoryEntry {
    constructor () {
        this.id = null
        this.message = ''
        this.sentByUserId = ''
        this.sentByUserFullName = ''
        this.sentAtDateTime = null
        this.recipientCount = 0
        this.deliveredCount = 0
        this.deliveryPercent = 0
        this.recipientStatuses = []
    }
}

export class RecipientStatus {
    constructor () {
        this.id = null
        this.recipientId = ''
        this.recipientFullName = ''
        this.recipientPhoneNumber = ''
        this.status = 0
        this.statusName = 'Unknown'
        this.statusUpdatedAtDateTime = null
    }
}

const getDefaultState = () => {
    return {
        history: []
    }
}

export const state = getDefaultState()

export const mutations = {
    SET_HISTORY_LIST (state, history) {
        state.history = history
    },
    ADD_HISTORY (state, newHistory) {
        state.history.push(newHistory)
    },
    ADD_OR_UPDATE_LIST_HISTORY (state, addOrUpdHistory) {
        const index = state.history.findIndex(h => h.id === addOrUpdHistory.id)
        if (index === -1) {
          state.history.push(addOrUpdHistory)
        } else {
          state.history.splice(index, 1, addOrUpdHistory)
        }
      },
    RESET_STATE (state) {
        // Merge rather than replace so we don't lose observers
        // https://github.com/vuejs/vuex/issues/1118
        Object.assign(state, getDefaultState())
    }
}

export const actions = {
    createMessage ({ commit }, message) {
        return ApiServiceBase.create({
            resource: 'message/send',
            data: {
                message: message
            },
            query: null
          }).then(response => {
            commit('ADD_HISTORY', response.data)
            return response
          })
    },
    loadHistory ({ commit }) {
        return ApiServiceBase.find({
            resource: 'message/history',
            query: null
        }).then(response => {
            commit('SET_HISTORY_LIST', response.data)
        })
    },
    getHistory ({ commit }, historyId) {
        return new Promise((resolve, reject) => {
            if (!historyId) {
                resolve(new HistoryEntry())
            } else {
                ApiServiceBase.get({
                    resource: 'message/history',
                    id: historyId,
                    query: null
                }).then(response => {
                    commit('ADD_OR_UPDATE_LIST_HISTORY', response.data)
                    resolve(response.data)
                }).catch(err => {
                    reject(err)
                })
            }
        })
    },
    getSubscriberCount () {
        return ApiServiceBase.find({
            resource: 'message/subscriber/count',
            query: null
        })
    }
}

export const getters = {
}
